import { withFormField } from '@gogame/form';

import AmountField from './AmountField';
import { validateAmount } from './helpers';

export * from './helpers';

export default withFormField({
  validate: validateAmount,
})(AmountField);
